import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	MatIconModule,
	MatSlideToggleModule,
	MatButtonModule,
	MatFormFieldModule,
	MatSelectModule,
	MatButtonToggleModule,
	MatDialogModule
} from '@angular/material';
import { IconSelectComponent } from './icon-select.component';

@NgModule({
	declarations: [IconSelectComponent],
	imports: [
		CommonModule,
		MatIconModule,
		MatSlideToggleModule,
		MatFormFieldModule,
		MatSelectModule,
		MatDialogModule,
		MatButtonToggleModule,
		MatButtonModule
	],
	exports: [IconSelectComponent],
	entryComponents: [IconSelectComponent]
})
export class IconSelectModule {}
